exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gengxinrizhi[data-v-4be96760] {\n    border-bottom: 1px solid #f5f5f5;\n    padding: 20px;\n}\n.nomore[data-v-4be96760] {\n    text-align: center;\n    color: #aaa;\n    padding: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4be96760","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Updatelog.vue
// module id = /I24
// module chunks = 142